<template>
  <div :style="cssVars" v-if="selectedOutcome">
    <page-layout
      headerPadding="q-px-sm"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <div class="col">
            <div class="row">
              <span
                :style="`color: ${cssVars['--outcome-secondary']}`"
                class="title"
              >
                {{
                  currentUserData.sustainabilityBusiness_name
                    ? currentUserData.sustainabilityBusiness_name
                    : "Test Business"
                }}
              </span>
            </div>
            <div class="row justify-between item-center">
              <div class="row items-center q-mt-none">
                <span class="dropdownTitle text-white">
                  Emissions Calculator
                </span>
                <div class="q-ml-sm">
                  <year-picker
                    :initial-year="selectedYear"
                    ref="yearPicker"
                    label="for"
                    @selectYear="selectYear"
                    :bg="cssVars['--outcome-secondary']"
                  ></year-picker>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-auto"
            style="position: relative; min-width: 260px; max-width: 260px"
          >
            <summary-stats-card
              style="position: absolute; top: -17px; right: -17px"
              :bg="cssVars['--outcome-secondary']"
              :slides="summaryStatsCardSlides"
              @editCarbonEmissionsTotal="editCustomTotal"
            />
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div class="row q-mt-md">
          <div style="width: 25%">
            <q-card class="shadow-10 full-height" flat>
              <q-card-section class="q-py-none" style="padding-top: 12px">
                <span
                  class="categoryHeader"
                  :style="`color:${cssVars['--outcome-secondary']};`"
                >
                  CATEGORY
                </span>
              </q-card-section>
              <q-scroll-area
                style="height: calc(100vh - 285px)"
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
                :visible="true"
              >
                <q-list class="q-mt-md q-pa-md">
                  <q-card
                    class="categoryCard no-shadow"
                    :class="{ categoryCardSelected: selectedCategory == 'all' }"
                  >
                    <q-item dense @click="filterCategory('all')" clickable>
                      <span class="categoryText"> All </span>
                    </q-item>
                  </q-card>

                  <q-card
                    class="categoryCard no-shadow"
                    :class="{
                      categoryCardSelected:
                        typeof selectedCategory === 'object'
                          ? selectedCategory.id == category.id
                          : false,
                    }"
                    @click="filterCategory(category)"
                    v-for="(category, i) in filteredCategories"
                    :key="i"
                    v-if="categoryKeys[category.id]"
                  >
                    <q-item clickable dense>
                      <div class="row justify-between items-center full-width">
                        <div class="col">
                          <span class="categoryText">
                            {{ category.name }}
                          </span>
                        </div>

                        <!-- <div class="col-shrink">
                          <span class="category-number">
                            {{
                              category != "all"
                                ? getNumberOfDataByCategory(category.id)
                                : ""
                            }}
                          </span>
                        </div> -->
                      </div>
                    </q-item>
                  </q-card>
                </q-list>
              </q-scroll-area>
            </q-card>
          </div>
          <div class="col" style="width: 75%">
            <div class="row" style="height: calc(100vh - 250px)">
              <div class="col-12">
                <q-card class="shadow-15 q-px-xs" flat>
                  <sustainability-data-table
                    style="height: calc(100vh - 250px) !important"
                    ref="datatable"
                    :data="filteredData"
                    :columns="columns"
                    @rowDoubleClick="onDoubleClick"
                    @rowSelected="selectData"
                    updateBody
                    rowKey="sources_id"
                    bodyHoverColor="#4ac7e933"
                    flat
                    :hideBottom="true"
                    :square="true"
                    separator="none"
                    headerBgColor="white"
                    :headerDark="true"
                    id="solutionsTable"
                  >
                    <!--LIST TILE LAYOUT-->
                    <template slot="body" slot-scope="data">
                      <q-tr
                        v-ripple
                        class="bg-white text-black"
                        @click="
                          $refs.datatable.handleClick(null, data.props.row)
                        "
                        @dblclick="
                          $refs.datatable.handleDoubleClick(
                            null,
                            data.props.row
                          )
                        "
                        :props="data.props"
                      >
                        <template
                          v-for="column in data.props.cols"
                          :name="`body-cell-${column.name}`"
                          v-bind:props="data.props"
                        >
                          <q-td
                            v-if="column.name == 'sourceName'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="sourceColumn-div">
                              <span class="sourceColumn">
                                {{ data.props.row.name }}
                                {{
                                  data.props.row.negativeLabel &&
                                  data.props.row.negative
                                    ? `(${data.props.row.negativeLabel})`
                                    : data.props.row.positiveLabel &&
                                      !data.props.row.negative
                                    ? `(${data.props.row.positiveLabel})`
                                    : ""
                                }}
                                <q-tooltip>
                                  {{ data.props.row.name }}
                                  {{
                                    data.props.row.negativeLabel &&
                                    data.props.row.negative
                                      ? `(${data.props.row.negativeLabel})`
                                      : data.props.row.positiveLabel &&
                                        !data.props.row.negative
                                      ? `(${data.props.row.positiveLabel})`
                                      : ""
                                  }}
                                </q-tooltip>
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'total'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="totalColumn-div">
                              <span
                                class="sourceColumn"
                                style="display: inline"
                              >
                                {{
                                  Number.isInteger(data.props.row.total)
                                    ? data.props.row.total
                                    : data.props.row.total.toFixed(2)
                                      | numberFormat
                                }}
                              </span>
                              <span
                                class="totalColumn-unit text-accent"
                                style="display: inline"
                              >
                                {{ data.props.row.unit }}
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'emissionsFactor'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="row items-center">
                              <span class="emission">
                                {{
                                  factorCalculation(
                                    !data.props.row.external
                                      ? getTotalDefaultEmission(data.props.row)
                                        ? getTotalDefaultEmission(
                                            data.props.row
                                          ).toFixed(2)
                                        : getTotalDefaultEmission(
                                            data.props.row
                                          )
                                      : data.props.row.customEmissionsFactor
                                      ? isNaN(
                                          parseFloat(
                                            data.props.row.customEmissionsFactor
                                              .totalValue
                                          )
                                        )
                                        ? ""
                                        : parseFloat(
                                            data.props.row.customEmissionsFactor
                                              .totalValue
                                          )
                                      : ""
                                  ) | numberFormat
                                }}
                              </span>
                            </div>
                          </q-td>
                          <q-td
                            v-else-if="column.name == 'editColumn'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="row items-center">
                              <span
                                v-if="
                                  isUseCustomEmissionsFactor(data.props.row)
                                "
                                class="emission"
                              >
                                <span
                                  @click="onDoubleClick(data.props.row)"
                                  class="editButton cursor-pointer"
                                >
                                  Edit
                                </span>
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'carbonFactorSource'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="row justify-end items-center">
                              <q-toggle
                                v-model="data.props.row.external"
                                @input="toggleCustomEmission(data.props.row)"
                              >
                              </q-toggle>
                              <div
                                :class="`externalEmission ${
                                  !isUseCustomEmissionsFactor(data.props.row)
                                    ? 'bg-accent'
                                    : 'bg-primary'
                                }`"
                              >
                                <div class="row justify-between items-center">
                                  <span class="text-white text">
                                    {{
                                      !isUseCustomEmissionsFactor(
                                        data.props.row
                                      )
                                        ? "Default Used"
                                        : "External Used"
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'actions'"
                            :key="column.name"
                            :props="data.props"
                          >
                          </q-td>

                          <q-td v-else :key="column.name" :props="data.props">
                            {{ column.value }}
                          </q-td>
                        </template>
                      </q-tr>
                    </template>
                  </sustainability-data-table>
                </q-card>
              </div>
            </div>
          </div>
        </div>
        <div class="row q-px-md q-pt-sm">
          <q-btn
            @click="
              $router.push(
                `${$route.path.split('emissionCalculator')[0]}dataUpload${
                  $route.path.split('emissionCalculator')[1]
                }`
              )
            "
            class="q-px-sm q-py-xs bg-secondary"
            no-caps
            flat
          >
            <span class="text-white text"> Back</span>
          </q-btn>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-py-md q-px-lg" style="height: calc(109px)">
            <div class="row full-height items-center">
              <span class="title"> Source Summary </span>
            </div>
          </div>
          <div class="col-auto q-pa-lg" style="height: calc(100vh - 226px)">
            <div v-if="selectedSource">
              <div>
                <div class="row">
                  <span class="sourceName text-accent">
                    {{ selectedSource.name }}
                  </span>
                </div>
                <div class="row">
                  <span class="totalAndUnit">
                    {{
                      Number.isInteger(selectedSource.total)
                        ? selectedSource.total
                        : selectedSource.total.toFixed(2) | numberFormat
                    }}
                    {{ selectedSource.unit }}
                  </span>
                </div>
                <div class="row">
                  <span class="yearFont"
                    >in
                    {{
                      typeof $refs.yearPicker.selectedYear == "number"
                        ? $refs.yearPicker.selectedYear
                        : parseFloat(
                            $refs.yearPicker.selectedYear.split("/")[0]
                          )
                    }}
                  </span>
                </div>
                <div class="row q-mt-md">
                  <span class="whichGenerated"> which generated </span>
                </div>
                <div
                  v-if="!selectedSource.external"
                  class="row q-mt-sm"
                  style="height: 40px"
                >
                  <span
                    class="totalAndUnit"
                    v-if="getTotalDefaultEmission(selectedSource)"
                  >
                    {{
                      factorCalculation(getTotalDefaultEmission(selectedSource))
                        | numberFormat
                    }}
                    {{
                      factorUnit(
                        filteredData[0]
                          ? filteredData[0].emissionsFactor[0].unit
                          : ""
                      )
                    }}
                  </span>
                </div>
                <div v-else class="row q-mt-sm" style="height: 40px">
                  <span
                    class="totalAndUnit"
                    v-if="selectedSource.customEmissionsFactor"
                  >
                    {{
                      factorCalculation(
                        selectedSource.customEmissionsFactor.totalValue
                      ) | numberFormat
                    }}
                    {{
                      factorUnit(
                        filteredData[0]
                          ? filteredData[0].emissionsFactor[0].unit
                          : ""
                      )
                    }}
                  </span>
                </div>

                <div class="row justify-between q-mt-lg">
                  <div>
                    <div class="row">
                      <span class="averageTotalUnits"
                        >{{ getMonthlyAverage | numberFormat }}
                        {{ selectedSource.unit }}
                      </span>
                    </div>
                    <div class="row">
                      <span
                        class="averageTotalUnits"
                        v-if="
                          getCustomTotalEmission(
                            getMonthlyAverage,
                            selectedSource
                          )
                        "
                      >
                        {{
                          factorCalculation(
                            getCustomTotalEmission(
                              getMonthlyAverage,
                              selectedSource
                            )
                          ) | numberFormat
                        }}
                        {{
                          factorUnit(
                            filteredData[0]
                              ? filteredData[0].emissionsFactor[0].unit
                              : ""
                          )
                        }}
                      </span>
                    </div>
                    <div class="averageTitle">Monthly Average</div>
                  </div>
                  <div>
                    <div class="row">
                      <span class="averageTotalUnits">
                        {{ getQuarterlyAverage | numberFormat }}
                        {{ selectedSource.unit }}
                      </span>
                    </div>
                    <div class="row">
                      <span
                        class="averageTotalUnits"
                        v-if="
                          getCustomTotalEmission(
                            getQuarterlyAverage,
                            selectedSource
                          )
                        "
                      >
                        {{
                          factorCalculation(
                            getCustomTotalEmission(
                              getQuarterlyAverage,
                              selectedSource
                            )
                          ) | numberFormat
                        }}
                        {{
                          factorUnit(
                            filteredData[0]
                              ? filteredData[0].emissionsFactor[0].unit
                              : ""
                          )
                        }}
                      </span>
                    </div>
                    <div class="averageTitle">Quarterly Average</div>
                  </div>
                </div>

                <div class="row justify-center q-mt-lg">
                  <q-separator style="width: 200px" />
                </div>

                <div class="row defaultEmissionBlurb q-mt-md">
                  <p v-if="isUseCustomEmissionsFactor(selectedSource)">
                    An externally provide carbon emission factor has been used
                    for this source. The totals have been manually entered by
                    the user of this organisation
                  </p>
                  <p
                    v-else-if="
                      getLatestFactorToTheSelectedYear(selectedSource) &&
                      filteredData[0] &&
                      filteredData[0].emissionsFactor[0] &&
                      !filteredData[0].emissionsFactor[0].hideBlurb
                    "
                  >
                    The emissions factor that we have used to determine your
                    {{
                      filteredData[0]
                        ? filteredData[0].emissionsFactor[0].unit
                        : ""
                    }}
                    for this source was
                    <strong
                      >{{
                        getLatestFactorToTheSelectedYear(selectedSource)
                          .emissionsFactor
                      }}
                      {{
                        getLatestFactorToTheSelectedYear(selectedSource).unit
                      }}</strong
                    >. Based off the NZ government detailed emissions guide
                    <a
                      style="color: #162c47; font-weight: 800"
                      target="_blank"
                      :href="
                        checkUrl(
                          getLatestFactorToTheSelectedYear(selectedSource).url
                        )
                      "
                      >found here</a
                    >
                    . As at
                    <strong>
                      {{
                        getLatestFactorToTheSelectedYear(selectedSource)
                          .created_at | slashDate
                      }}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
            <div v-else>
              <br />
              <br />
              Welcome to your <b class="highlight">Source Summary</b>, here is
              where you will gain greater insights in to the data you’ve entered
              for this outcome. <br />
              <br />
              <i style="font-size: 0.7rem"
                >Click on any source to reveal greater insights</i
              >
            </div>
          </div>
          <div class="col q-px-md">
            <q-btn
              @click="
                $router.push(
                  `${$route.path.split('emissionCalculator')[0]}dataSummary${
                    $route.path.split('emissionCalculator')[1]
                  }`
                )
              "
              class="q-px-sm q-py-xs float-right"
              :style="`background: ${cssVars['--outcome-secondary']}`"
              no-caps
              flat
            >
              <span class="text-white text"> Next </span>
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
    <q-dialog v-model="emissionFactorDialog" persistent>
      <custom-emission-factor-dialog
        @closeDialog="closeEmissionsFactorDialog"
        :outcomeStyle="cssVars"
      ></custom-emission-factor-dialog>
    </q-dialog>

    <q-dialog v-model="emissionYearTotalDialog" persistent>
      <custom-emission-year-total-form
        :selectedYear="selectedYear"
        @closeDialog="closeCustomTotalDialog"
        :outcomeStyle="cssVars"
        :currentTotal="calculateTotalEmissionsBasedOnData"
      ></custom-emission-year-total-form>
    </q-dialog>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import PageLayout from "@/components/pageLayout/pageLayout.vue";
  import YearPicker from "@/components/generalComponents/yearPicker.vue";
  import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
  import { getMonths } from "@/functions/getMonths";
  import customEmissionFactorDialog from "@/components/customEmissionFactorDialog/customEmissionFactorDialog.vue";
  import customEmissionYearTotalForm from "@/components/customEmissionYearTotalForm/customEmissionYearTotalForm.vue";
  import SummaryStatsCard from "@/components/generalComponents/summaryStatsCard.vue";

  export default {
    components: {
      PageLayout,
      YearPicker,
      SustainabilityDataTable,
      customEmissionFactorDialog,
      customEmissionYearTotalForm,
      SummaryStatsCard,
    },
    mounted() {
      this.init();
      this.handleRoute();
    },
    watch: {
      $route: {
        handler(value) {
          this.handleRoute();
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        currentUserData: "auth/currentUserData",
        outcomesCategories: "outcomes/categories/listForData",
        data: "sources/data/list",
        businessExtra: "businessExtra/data",
      }),
      categoryKeys() {
        let categoryKeys = {};
        this.data.forEach((e) => {
          if (e.total) {
            categoryKeys[e.categories_id] = true;
          }
        });

        return categoryKeys;
      },
      summaryStatsCardSlides() {
        let unit = this.selectedOutcome.factorUnitDisplay
          ? this.selectedOutcome.factorUnitDisplay
          : this.filteredData[0]
          ? this.filteredData[0].emissionsFactor[0].unit
          : "";
        let factorMultiplier = this.selectedOutcome.factorMultiplier
          ? this.selectedOutcome.factorMultiplier
          : 1;

        let slides = [
          {
            cardTitle: `${this.selectedOutcome.label} (${unit})`,
            cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${(
              this.calculateTotalEmissionsBasedOnData * factorMultiplier
            ).toFixed(
              2
            )} <span style='font-size: 14px; font-weight: 800'>(${unit})</span></h3>`,
            subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>based on your current data entries</span>`,
          },
        ];
        if (
          this.selectedOutcome.negativeLabel &&
          this.selectedOutcome.positiveLabel
        ) {
          let intensity =
            this.businessExtra && this.businessExtra.annualRevenue
              ? (
                  (this.splitData.negative * factorMultiplier) /
                  (this.businessExtra.annualRevenue / 1000000)
                ).toFixed(2)
              : 0;
          const extraSlides = [
            {
              cardTitle: `${this.selectedOutcome.label} (${this.selectedOutcome.positiveLabel})`,
              cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${this.$options.filters.numberFormat(
                this.splitData.positive * factorMultiplier
              )} <span style='font-size: 14px; font-weight: 800'>(${unit})</span></h3>`,
              subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>based on your current data entries</span>`,
            },
            {
              cardTitle: `${this.selectedOutcome.label} (${this.selectedOutcome.negativeLabel})`,
              cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${this.$options.filters.numberFormat(
                this.splitData.negative * factorMultiplier
              )} <span style='font-size: 14px; font-weight: 800'>(${unit})</span></h3>`,
              subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>based on your current data entries</span>`,
            },
            {
              cardTitle: `Your ${this.selectedOutcome.label} Intensity`,
              cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${intensity} <span style='font-size: 14px; font-weight: 800'>${unit}/$1M</span></h3>`,
              subContent: `<span style='color: ${
                this.cssVars["--outcome-primary"]
              }'>based on $${this.$options.filters.numberFormat(
                this.businessExtra.annualRevenue
              )} gross revenue</span>`,
            },
          ];
          slides.push(...extraSlides);
        } else {
          let intensity =
            this.businessExtra && this.businessExtra.annualRevenue
              ? (
                  (this.calculateTotalEmissionsBasedOnData * factorMultiplier) /
                  (this.businessExtra.annualRevenue / 1000000)
                ).toFixed(2)
              : 0;
          const extraSlides = [
            {
              cardTitle: `Your ${this.selectedOutcome.label} Intensity`,
              cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${intensity} <span style='font-size: 14px; font-weight: 800'>${unit}/$1M</span></h3>`,
              subContent: `<span style='color: ${
                this.cssVars["--outcome-primary"]
              }'>based on $${this.$options.filters.numberFormat(
                this.businessExtra.annualRevenue
              )} gross revenue</span>`,
            },
          ];
          slides.push(...extraSlides);
        }
        return slides;
      },
      splitData() {
        let returnData = {
          negative: 0,
          positive: 0,
        };
        if (this.filteredData.length > 0) {
          this.filteredData.forEach((e) => {
            let currentEmissions = 0;
            if (!e.external && e.emissionsFactor.length > 0) {
              currentEmissions += this.getTotalDefaultEmission(e);
            } else if (e.external && e.customEmissionsFactor) {
              if (!isNaN(parseFloat(e.customEmissionsFactor.totalValue))) {
                currentEmissions += parseFloat(
                  e.customEmissionsFactor.totalValue
                );
              }
            }

            if (e.negative) {
              returnData.negative += currentEmissions;
            } else {
              returnData.positive += currentEmissions;
            }
          });
        }
        return returnData;
      },
      formattedSelectedYear() {
        if (typeof this.selectedYear === "string") {
          return this.selectedYear.split("/")[0];
        } else {
          return this.selectedYear;
        }
      },
      getMonthlyAverage() {
        if (this.selectedSource) {
          return this.selectedSource.total / 12;
        }
      },
      getQuarterlyAverage() {
        if (this.selectedSource) {
          return this.selectedSource.total / 3;
        }
      },
      calculateTotalEmissionsBasedOnData() {
        let totalEmissions = 0;
        if (this.filteredData.length > 0) {
          this.filteredData.forEach((e) => {
            if (!e.external && e.emissionsFactor.length > 0) {
              totalEmissions += this.getTotalDefaultEmission(e);
            } else if (e.external && e.customEmissionsFactor) {
              if (!isNaN(parseFloat(e.customEmissionsFactor.totalValue))) {
                totalEmissions += parseFloat(e.customEmissionsFactor.totalValue);
              }
            }
          });
        }
        return totalEmissions;
      },
      columns() {
        let columns = [
          {
            name: "sourceName",
            label: "Source",
            align: "left",
            field: "name",
            boldItems: true,
            capsHeader: true,
            boldHeader: true,
            headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
            style:
              "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },

          {
            name: "total",
            label: "Year Total",
            align: "left",
            field: "total",
            boldHeader: true,
            headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
            extendedCSS:
              "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
            style:
              "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];

        if (this.selectedOutcome.usesFactor) {
          const extraColumns = [
            {
              name: "emissionsFactor",
              label: `${
                this.filteredData[0]
                  ? this.factorUnit(this.filteredData[0].emissionsFactor[0].unit)
                  : ""
              }`,
              align: "left",
              field: "emissionsFactor",
              boldHeader: true,
              headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
              extendedCSS:
                "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
              style:
                "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
              format: (val, row) => {
                if (row.emissionsFactor.length > 0) {
                  return val[val.length - 1].emissionsFactor;
                }
              },
            },
            {
              name: "editColumn",
              label: "",
              align: "left",
              field: "emissionsFactor",
              boldHeader: true,
              headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
              extendedCSS:
                "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
              style:
                "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
              format: (val, row) => {
                if (row.emissionsFactor.length > 0) {
                  return val[val.length - 1].emissionsFactor;
                }
              },
            },
            {
              name: "carbonFactorSource",
              label: `${this.selectedOutcome.label} Factor Source`,
              boldHeader: true,
              headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
              style:
                "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            },
          ];
          columns.push(...extraColumns);
        }

        return columns;
      },
      filteredCategories() {
        return this.outcomesCategories.sort((a, b) => (a.rank > b.rank ? 1 : -1));
      },
      cssVars() {
        let primaryColorFaded = this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"];
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      },
    },
    data: () => ({
      selectedOutcome: null,
      selectedCategory: "all",
      filteredData: [],
      selectedSource: null,
      emissionFactorDialog: false,
      emissionYearTotalDialog: false,
      selectedYear: null,
    }),
    methods: {
      isUseCustomEmissionsFactor(row) {
        if (row.customEmissionsFactor) {
          if (row.customEmissionsFactor.useCustom) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      selectYear(val) {
        this.selectedYear = val.split("/")[0];
        this.$router.push(
          `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
        );
        this.$store
          .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
            id: this.selectedOutcome.id,
            year: this.selectedYear,
          })
          .then((e) => {
            this.filterData();
          });
      },
      async toggleCustomEmission(row) {
        let useCustom = this.isUseCustomEmissionsFactor(row) ? 0 : 1;
        let result = await this.$store.dispatch(
          "customSourcesBusinessTotal/new",
          {
            sources_id: row.sources_id,
            useCustom: useCustom,
            date: this.selectedYear,
          }
        );

        if (useCustom == 1) {
          this.$router.push(this.$route.path + "/source/" + row.sources_id);
        }

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: "Setting saved, Please click edit to enter data",
          });
          this.init();
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      getMonths: getMonths,
      isSelected(row, selectedArray) {
        let index = selectedArray.findIndex((e) => e.id == row.id);
        if (index > -1) {
          return true;
        } else {
          return false;
        }
      },
      closeEmissionsFactorDialog() {
        this.$router.push(`${this.$route.path.split("/source")[0]}`);
        this.init();
        this.emissionFactorDialog = false;
      },
      handleRoute() {
        if (
          this.$route.params.hasOwnProperty("sourceId") &&
          this.$route.params.hasOwnProperty("year")
        ) {
          this.emissionFactorDialog = true;
        }
      },
      onDoubleClick(data) {
        this.$router.push(this.$route.path + "/source/" + data.sources_id);
      },
      filterCategory(category) {
        this.selectedCategory = category;
        this.filterData();
      },
      selectData(data) {
        this.selectedSource = data;
      },
      getLatestFactorToTheSelectedYear(data) {
        let selectedYear =
          typeof this.$refs.yearPicker.selectedYear == "number"
            ? this.$refs.yearPicker.selectedYear
            : parseFloat(this.$refs.yearPicker.selectedYear.split("/")[0]);

        if (data.emissionsFactor.length > 0) {
          let latestEmissionFactor = data.emissionsFactor[0];
          data.emissionsFactor.forEach((e) => {
            if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
              latestEmissionFactor = { ...e };
            }
          });
          return latestEmissionFactor;
        } else {
          return null;
        }
      },
      checkUrl(url) {
        if (!url.includes("http")) {
          return "https://" + url;
        } else {
          return url;
        }
      },
      getCustomTotalEmission(totalValue, data) {
        let latestEmissionFactor = this.getLatestFactorToTheSelectedYear(data);
        if (latestEmissionFactor) {
          if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
            return (
              (parseFloat(totalValue) *
                parseFloat(latestEmissionFactor.emissionsFactor)) /
              1000
            );
          } else {
            return (
              parseFloat(totalValue) *
              parseFloat(latestEmissionFactor.emissionsFactor)
            );
          }
        } else {
          return null;
        }
      },
      getTotalDefaultEmission(data) {
        //get the chosen year

        let selectedYear =
          typeof this.$refs.yearPicker.selectedYear == "number"
            ? this.$refs.yearPicker.selectedYear
            : parseFloat(this.$refs.yearPicker.selectedYear.split("/")[0]);

        if (data.emissionsFactor.length > 0) {
          //get the latest emissions factor of the selected year
          let latestEmissionFactor = data.emissionsFactor[0];
          data.emissionsFactor.forEach((e) => {
            if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
              latestEmissionFactor = { ...e };
            }
          });
          if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
            return (
              (parseFloat(data.total) *
                parseFloat(latestEmissionFactor.emissionsFactor)) /
              1000
            );
          } else {
            return (
              parseFloat(data.total) *
              parseFloat(latestEmissionFactor.emissionsFactor)
            );
          }
        }
      },
      filterData() {
        let currentData = this.data;
        currentData = currentData.filter((e) => e.total);
        currentData = currentData
          .filter((e) => {
            if (this.selectedCategory == "all") {
              return e;
            } else {
              if (e.categories_id == this.selectedCategory.id) {
                return e;
              }
            }
          })
          .sort((a, b) => (a.rank > b.rank ? 1 : -1));
        currentData = currentData.map((e) => {
          if (this.isUseCustomEmissionsFactor(e)) {
            return { ...e, external: true };
          } else {
            return { ...e, external: false };
          }
        });

        this.filteredData = currentData;
      },
      init() {
        this.selectedYear = this.$route.params.year
          ? this.$route.params.year
          : this.$moment().format("YYYY");
        console.log(this.selectedYear);
        this.$store.dispatch("outcomes/loadAll").then((e) => {
          if (this.outcomesList.length > 0) {
            this.tab = this.outcomesList[0].name;
            if (this.$route.params.hasOwnProperty("outcomesID")) {
              let index = this.outcomesList.findIndex(
                (o) => this.$route.params.outcomesID == o.id
              );

              this.selectedOutcome = this.outcomesList[index];
            } else {
              this.selectedOutcome = this.outcomesList[0];
            }

            this.$store.dispatch(
              "outcomes/categories/loadAllByOutcomesID",
              this.selectedOutcome.id
            );
            this.$store
              .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
                id: this.selectedOutcome.id,
                year: this.selectedYear,
              })
              .then((e) => {
                this.filterData();
              });
          }
        });
      },
      editCustomTotal() {
        this.emissionYearTotalDialog = true;
      },
      closeCustomTotalDialog(init) {
        this.emissionYearTotalDialog = false;
        if (init) {
          this.$store
            .dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
              id: this.selectedOutcome.id,
              year: this.selectedYear,
            })
            .then((e) => {
              this.filterData();
            });
        }
      },

      factorCalculation(data) {
        if (
          this.selectedOutcome &&
          this.selectedOutcome.factorMultiplier &&
          data
        ) {
          return data * this.selectedOutcome.factorMultiplier;
        } else {
          return data;
        }
      },
      factorUnit(data) {
        if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
          return this.selectedOutcome.factorUnitDisplay;
        } else {
          return data;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  /*topbar */
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
  .dropdownTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }

  .subtitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
  }

  .value {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    text-align: right;
  }

  .sidebar {
    background-color: #f6f6f6;
    .title {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      color: var(--outcome-secondary);
    }

    .sourceName {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 15.9366px;
    }

    .totalAndUnit {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 27.0146px;
      color: var(--outcome-primary);
    }

    .averageTitle {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 10px;
    }

    .yearFont {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 15.9362px;
    }

    .whichGenerated {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 10.1305px;
    }

    .defaultEmissionBlurb {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
    }

    .averageTotalUnits {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 900;
      font-size: 16px;
      color: var(--outcome-primary);
    }
  }

  .categoryHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: var(--outcome-primary);
  }

  .editButton {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    text-decoration: underline;
  }

  .categoryCard {
    margin-bottom: 20px;

    .categoryText {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
    }
  }

  .sourceColumn-div {
    width: 190px;
    text-align: left;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .sourceColumn {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    overflow: hidden;
    color: var(--outcome-secondary);
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .emission {
    font-family: "Montserrat";
    font-style: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 400;
    font-size: 14px;
    color: var(--outcome-secondary);

    .editButton {
      font-size: 11px;
      text-decoration: underline;
    }
  }

  .unit {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
  }

  .externalEmission {
    border-radius: 3px;
    padding: 6px 12px;
    .text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 600;
      font-size: 9px;
    }
  }

  .categoryCardSelected {
    background-color: var(--outcome-primary-faded);
  }
</style>
